import React from 'react';
import { AccordionItem, AccordionButton, Box, Heading, AccordionPanel, useAccordionContext, } from '@chakra-ui/react';
import Chevron, { ChevronDirection } from '../../../icons/Chevron';
const EditFindingAccordionItem = ({ title, children, index, ...rest }) => {
    const { index: actualIndex } = useAccordionContext();
    return (React.createElement(AccordionItem, { ...rest },
        React.createElement(AccordionButton, null,
            React.createElement(Box, { flex: "1", textAlign: "left" },
                React.createElement(Heading, { "data-testid": "edit_finding_accordion_item__heading", variant: "dk-800-md-6", as: "h3" }, title)),
            React.createElement(Chevron, { direction: actualIndex === index ? ChevronDirection.DOWN : ChevronDirection.UP })),
        React.createElement(AccordionPanel, null, children)));
};
export default EditFindingAccordionItem;
